import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/stores-v2';

const fromAvailabilityStoresNearbyQueryToStore = (queryData)=>{
    if (!queryData || queryData.availability.length === 0) {
        return null;
    }
    try {
        return queryData.availability.map((entry)=>{
            const { streetNumber , postalCode , province , distance , hearingAppointmentPossible  } = entry.store;
            const { slotsAvailable , nextAvailableBookingDate  } = entry;
            const accessibility = entry.store.accessibility || [];
            return {
                slotsAvailable,
                nextAvailableBookingDate: nextAvailableBookingDate ? new Date(nextAvailableBookingDate) : undefined,
                store: swcHelpers.objectSpread({}, entry.store, {
                    streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
                    postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
                    province: province !== null && province !== void 0 ? province : undefined,
                    distance: distance !== null && distance !== void 0 ? distance : undefined,
                    appointmentTypes: [],
                    wheelchairAccessible: accessibility.includes(Types.ACCESSIBILITY_WHEELCHAIR),
                    hearingAppointmentPossible: Boolean(hearingAppointmentPossible)
                })
            };
        });
    } catch (e) {
        console.error('fromAvailabilityStoresNearbyQueryToStore data adapter failed to parse input data correctly.', e, queryData);
        return null;
    }
};

export { fromAvailabilityStoresNearbyQueryToStore as default, fromAvailabilityStoresNearbyQueryToStore };
//# sourceMappingURL=fromAvailabilityStoresNearbyQueryToStore.js.map
